import { Container, Grid } from '@material-ui/core';
import React, { FC } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { get, isEmpty } from 'lodash';
import Document from 'components/Document';
import { handleOpenDocument } from 'services/utils';
import View from 'components/SahamIcons/View';
import { DocumentType } from 'components/JustificativeDocuments/type';
import { getContestationDocuments } from 'containers/LawyerLegalProceedingsPage/Contestation/utils';
import ContestationDocumentsForm from 'containers/LawyerLegalProceedingsPage/Contestation/ContestationDocumentsForm';
import { PROCEDURE_STATUSES } from 'containers/data-structure';
import { DOCUMENT_TYPES } from 'constants/global';

export interface ContestationDocumentsProps {
  intl: IntlShape;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  setDocumentId: Function;
  documentId: any;
  requestUploadContestationDocument?: Function | undefined;
  claimNumber?: string;
  status?: string;
  contestationId?: number;
  judgementOnMerits: any;
  isLawyer?: boolean;
  handleSuccessCallback: Function;
  isCivilProceeding?: boolean;
  requestGetDocByDocumentumId: Function;
}
const Picker = {
  CONTESTATION_DOCUMENTS: ({ ...props }) => {
    return (
      <Container className="subContainer">
        <Grid container spacing={3}>
          {getContestationDocuments(
            get(props.judgementOnMerits, 'jom.jmc.jmcd', []),
          ).map((el: DocumentType) => (
            <Grid key={el.id} item xs={12}>
              <Document
                name={el.name}
                type={el.type}
                icon={
                  <div
                    className="consult"
                    onClick={handleOpenDocument(
                      el as any,
                      props.requestGetDocByDocumentumId,
                    )}
                  >
                    <View />
                  </div>
                }
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    );
  },
  DEFAULT: ({ ...props }) => {
    const componentToRender =
      props.isCivilProceeding || props.isLawyer ? (
        <ContestationDocumentsForm
          judgementOnMerits={props.judgementOnMerits}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          resetUploadedDocument={props.resetUploadedDocument}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          contestationDocs={props.contestationDocs}
          setContestationDocs={props.setContestationDocs}
          {...props}
          contestationDocsToUpdate={get(
            props.judgementOnMerits,
            'jom.jmc.jmcd',
            [],
          ).filter(
            (jmcd: any) =>
              jmcd.type === DOCUMENT_TYPES.CONTESTATION_ACT ||
              jmcd.type === DOCUMENT_TYPES.CONTESTATION_REQUEST,
          )}
          isLawyer={props.isLawyer}
          handleSuccessCallback={props.handleSuccessCallback}
        />
      ) : (
        <></>
      );
    return componentToRender;
  },
};
const ContestationDocuments: FC<ContestationDocumentsProps> = props => {
  const [contestationDocs, setContestationDocs] = React.useState<null | any>(
    [],
  );
  const Component =
    !isEmpty(
      getContestationDocuments(
        get(props.judgementOnMerits, 'jom.jmc.jmcd', []),
      ),
    ) &&
    get(props.judgementOnMerits, 'jom.jmc.status', '') ===
      PROCEDURE_STATUSES.VALIDATED
      ? Picker['CONTESTATION_DOCUMENTS']
      : Picker['DEFAULT'];

  const RecapDocuments = Picker['CONTESTATION_DOCUMENTS'];
  return (
    <>
      <Component
        contestationDocs={contestationDocs}
        setContestationDocs={setContestationDocs}
        {...props}
      />
      {!(
        get(props.judgementOnMerits, 'jom.jmc.status', '') ===
        PROCEDURE_STATUSES.VALIDATED
      ) && (
        <RecapDocuments
          contestationDocs={contestationDocs}
          setContestationDocs={setContestationDocs}
          {...props}
        />
      )}
    </>
  );
};

export default injectIntl(ContestationDocuments);
